export default "__VITE_ASSET__9JrCxyMA__"